module.exports = __webpack_public_path__ + "static/aboutlastfree-3d8bd04ab32b061d0976bd4a7039323b.png";